"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ptShort = exports.ptForm = exports.pt = exports.default = void 0;

var _locale = _interopRequireDefault(require("./locale"));

var _localeForm = _interopRequireDefault(require("./localeForm"));

var _localeShort = _interopRequireDefault(require("./localeShort"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const pt = _locale.default;
exports.pt = pt;
const ptForm = _localeForm.default;
exports.ptForm = ptForm;
const ptShort = _localeShort.default;
exports.ptShort = ptShort;
var _default = {
  pt,
  ptForm,
  ptShort
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJwdCIsImxvY2FsZSIsInB0Rm9ybSIsImxvY2FsZUZvcm0iLCJwdFNob3J0IiwibG9jYWxlU2hvcnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7OztBQUVPLE1BQU1BLEVBQUUsR0FBR0MsZUFBWDs7QUFDQSxNQUFNQyxNQUFNLEdBQUdDLG1CQUFmOztBQUNBLE1BQU1DLE9BQU8sR0FBR0Msb0JBQWhCOztlQUVRO0FBQ2JMLEVBQUFBLEVBRGE7QUFFYkUsRUFBQUEsTUFGYTtBQUdiRSxFQUFBQTtBQUhhLEMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgbG9jYWxlIGZyb20gJy4vbG9jYWxlJztcbmltcG9ydCBsb2NhbGVGb3JtIGZyb20gJy4vbG9jYWxlRm9ybSc7XG5pbXBvcnQgbG9jYWxlU2hvcnQgZnJvbSAnLi9sb2NhbGVTaG9ydCc7XG5cbmV4cG9ydCBjb25zdCBwdCA9IGxvY2FsZTtcbmV4cG9ydCBjb25zdCBwdEZvcm0gPSBsb2NhbGVGb3JtO1xuZXhwb3J0IGNvbnN0IHB0U2hvcnQgPSBsb2NhbGVTaG9ydDtcblxuZXhwb3J0IGRlZmF1bHQge1xuICBwdCxcbiAgcHRGb3JtLFxuICBwdFNob3J0LFxufTtcbiJdfQ==